<div class="modal-header">
  <h5 class="modal-title">Add Invoice</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label class="form-label fw-semibold">Invoice Type</label>
    <input class="form-control" [(ngModel)]="invoiceDescription" maxlength="200">
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="!isLoading" type="button" class="btn btn-success" (click)="addInvoice()">Add</button>

  <button *ngIf="isLoading" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Adding...
  </button>
</div>